import React from "react";
import Page from "../../common/page/Page.js";
import useTranslationEmailSubscription from "../useTranslationEmailSubscription.js";
import SpotterUnsubscriptionBlock from "./SpotterUnsubscriptionBlock.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import { useParams } from "react-router";

export default function SpotterUnsubscriptionPage(/*props*/) {
  // Fetch the email provided in the url params.
  const urlParams = useParams();
  const email = urlParams.email;

  const { t, loading: tLoading } = useTranslationEmailSubscription();
  useShowLoader(tLoading, "SpotterUnsubscriptionPage");

  return (
    <Page className="SpotterUnsubscriptionPage">
      <Page.Title
        text={t("email-subscription:email_unsubscription_spotter_title")}
        loading={tLoading}
      />
      <Page.Content>
        <SpotterUnsubscriptionBlock email={email} />
      </Page.Content>
    </Page>
  );
}
